<template>
  <div>
    <el-timeline-item
      v-if="content"
      :icon="icon"
      :type="type"
      :color="color"
      size="large"
      :timestamp="formatDate(activity.createdOn)"
    >
      <div v-html="formattedActivityText" class=""></div>
    </el-timeline-item>
  </div>
</template>

<script>
import ActivitiesTimelineMixin from "@/components/ActivitiesView/ActivitiesTimelineMixin.vue";
import { formatDate } from "@/helpers/dateProcessor";
export default {
  mixins: [ActivitiesTimelineMixin],
  props: {
    activity: {
      type: Object,
      required: true
    },
    policyInquiry: {
      type: Object,
      required: false
    }
  },
  methods: {
    formatActivityData(activityType) {
      let content = "";
      if (activityType === "success") {
        content += "viewed policy inquiry.";
      } else {
        content += "failed to view policy inquiry.";
      }

      if (this.data?.policyNumber) {
        content += `<p>Policy Number: ${this.data.policyNumber}</p>`;
      }
      if (this.data?.effectiveDate) {
        content += `<p>Effective Date: ${formatDate(
          this.data.effectiveDate
        )}</p>`;
      }
      return content;
    }
  },
  watch: {
    activity: {
      async handler() {
        this.content = "";
        this.icon = "";
        this.type = "";
        this.link = {};
        this.color = "";
        switch (this.activity.name) {
          case "MAKE_POLICY_INQUIRY_SUCCESS":
            this.generateReadableGeneric({
              content: this.formatActivityData("success"),
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "MAKE_POLICY_INQUIRY_FAILURE":
            this.generateReadableFailGeneric({
              content: this.formatActivityData("failure"),
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
        }
      },
      immediate: true
    }
  }
};
</script>

<style></style>
